module.exports = __webpack_public_path__ + "static/media/declined.a52a304b.gif";